"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateStructuredData = exports.truncateDescription = exports.generatePageSEO = exports.generatePostSEO = void 0;
const config_1 = require("../constants/config");
const generatePostSEO = (post) => {
    const title = post.seo?.metaTitle || post.title;
    const keywords = post.seo?.keywords || post.tags;
    const ogImage = post.coverImage || `${config_1.CONFIG.SITE_URL}/images/og-post.png`;
    // Build OG title: include subtitle if available
    const ogTitle = post.subtitle ? `${title} — ${post.subtitle}` : title;
    // Build description: prefer metaDescription, then subtitle + excerpt, then just excerpt
    const description = post.seo?.metaDescription ||
        (post.subtitle ? `${post.subtitle}. ${post.excerpt}` : post.excerpt);
    // OG description: subtitle first, then excerpt as fallback
    const ogDescription = post.seo?.metaDescription || post.subtitle || post.excerpt;
    return {
        title: `${title} | ${config_1.CONFIG.SITE_TITLE}`,
        description: (0, exports.truncateDescription)(description),
        keywords,
        ogTitle,
        ogDescription: (0, exports.truncateDescription)(ogDescription),
        ogUrl: `${config_1.CONFIG.SITE_URL}/posts/${post.slug}`,
        ogImage,
        twitterCard: post.coverImage ? 'summary_large_image' : 'summary',
        canonicalUrl: `${config_1.CONFIG.SITE_URL}/posts/${post.slug}`,
        publishedTime: typeof post.publishedAt === 'string' ? post.publishedAt : post.publishedAt.toISOString(),
        modifiedTime: typeof post.updatedAt === 'string' ? post.updatedAt : post.updatedAt.toISOString(),
        author: post.author,
    };
};
exports.generatePostSEO = generatePostSEO;
const generatePageSEO = (title, description, path = '') => {
    return {
        title: title === config_1.CONFIG.SITE_TITLE ? title : `${title} | ${config_1.CONFIG.SITE_TITLE}`,
        description: description || config_1.CONFIG.SITE_DESCRIPTION,
        ogTitle: title,
        ogDescription: description || config_1.CONFIG.SITE_DESCRIPTION,
        ogUrl: `${config_1.CONFIG.SITE_URL}${path}`,
        ogImage: `${config_1.CONFIG.SITE_URL}/images/og-default.png`,
        twitterCard: 'summary',
        canonicalUrl: `${config_1.CONFIG.SITE_URL}${path}`,
    };
};
exports.generatePageSEO = generatePageSEO;
const truncateDescription = (text, maxLength = 160) => {
    if (text.length <= maxLength)
        return text;
    return text.substring(0, maxLength).replace(/\s+\S*$/, '') + '...';
};
exports.truncateDescription = truncateDescription;
const generateStructuredData = (post) => {
    const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: post.title,
        description: post.excerpt,
        image: post.coverImage || `${config_1.CONFIG.SITE_URL}/images/posts/${post.slug}.jpg`,
        datePublished: typeof post.publishedAt === 'string' ? post.publishedAt : post.publishedAt.toISOString(),
        dateModified: typeof post.updatedAt === 'string' ? post.updatedAt : post.updatedAt.toISOString(),
        author: {
            '@type': 'Person',
            name: post.author,
            url: config_1.CONFIG.SITE_URL,
        },
        publisher: {
            '@type': 'Organization',
            name: config_1.CONFIG.SITE_TITLE,
            url: config_1.CONFIG.SITE_URL,
        },
        mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': `${config_1.CONFIG.SITE_URL}/posts/${post.slug}`,
        },
        keywords: post.tags.join(', '),
        wordCount: post.wordCount,
        timeRequired: `PT${post.readingTimeMinutes}M`,
    };
    // Add subtitle if available
    if (post.subtitle) {
        structuredData.alternativeHeadline = post.subtitle;
    }
    // Add series information if available
    if (post.series) {
        structuredData.isPartOf = {
            '@type': 'BlogPosting',
            name: post.series.name,
            url: `${config_1.CONFIG.SITE_URL}/tags/${post.series.slug}`,
        };
    }
    // Add view count if available
    if (post.views) {
        structuredData.interactionStatistic = {
            '@type': 'InteractionCounter',
            interactionType: 'https://schema.org/ReadAction',
            userInteractionCount: post.views,
        };
    }
    return structuredData;
};
exports.generateStructuredData = generateStructuredData;
